import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';


/**
 * MergeOverlapDialog component for listing and merging routes.
 * Material-UI Dialog.
 *
 * @param {function}        props.open - Method to open this dialog.
 * @param {function}        props.onRequestClose - Method to hide this dialog.
 * @param {string}          props.regionType - Can be park or hike.
 * @param {number}          props.regionId - The id of the park or hike.
 *
 * @return {React.Component}
 */
export default class MergeOverlapDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleMergeOptionClick = this.handleMergeOptionClick.bind(this);
    }

    handleMergeOptionClick(id) {
        const url = '/api/trip/hike/merge-routes/';
        fetch(url,
            {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify({
                    target_kr_id: parseInt(this.props.regionId),
                    merge_into_kr_id: id,
                }),
            }
        )
            .then(response => {
                return response.json();
            })
            .then(() => {
                window.location = '/hike/' + id;
            });
    }

    render() {
        let routes = (<span> Loading overlapping routes ... </span>);
        if (this.props.loadedRoutes) {
            if (this.props.loadedRoutes.length > 0) {
                routes = this.props.loadedRoutes.map(item =>
                    (<div key={item.id}>
                        <Button
                            key={item.id}
                            variant="outlined"
                            onClick={this.handleMergeOptionClick.bind(this, item.id)}
                        >
                            Merge this known route
                        </Button>
                        &nbsp;
                        into <a href={'/hike/' + item.id + '/'}>{item.kr_title}</a>
                    </div>));
            } else {
                routes = <div> No overlapping routes </div>;
            }
        }
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onRequestClose}
                maxWidth={false}
            >
                <DialogTitle className="dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <div style={{marginTop: 20, width: '60vw'}}>
                        {routes}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        key={0}
                        variant="text"
                        onClick={this.props.onRequestClose}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
